<template>
  <aw-spring :desktop-size="10">
    <aw-breadcrumb-version2 :class="$style.breadcrumb" />
    <aw-cms-white-card
      mobile-negative-margin
      :class="$style.card"
    >
      <template #head>
        <lv-heading
          level="1"
          tag="h1"
          version2
        >
          {{ $awt('aw.pages.press.title') }}
        </lv-heading>
        <aw-separator />
        <div
          :class="$style.contactTitle"
        >
          <lv-heading
            level="2"
            tag="h2"
            version2
          >
            {{ $awt('aw.pages.press.contacts_title') }}
          </lv-heading>
        </div>
        <aw-contact-us :contacts="contacts" bordered />
      </template>
      <aw-aggregated-page-highlighted-carousel page-type="press_release" />
      <div :class="$style.head">
        <lv-heading
          level="2"
          tag="h2"
          version2
        >
          {{ $awt('aw.pages.press.card_title') }}
        </lv-heading>
        <aw-select-version2
          v-model:selected-options="selectedYear"
          :options="yearOptions"
          option-id-property="id"
          option-label-property="id"
          :inline-label-text="$awt('aw.pages.press.year.placeholder')"
          :multiple="false"
          :dropdown-icon-attrs="{
            name: 'arrow-down-16',
            size: 20
          }"
        />
      </div>
      <aw-aggregated-page-cards
        :key="selectedYear?.id"
        :params="{ year: selectedYear?.id }"
        page-type="press_release"
      />
    </aw-cms-white-card>
  </aw-spring>
</template>

<script setup lang="ts">
  import { computed, defineAsyncComponent, provide, ref } from 'vue';
  import { useNuxtApp } from 'nuxt/app';
  import { useBreadcrumbStore } from '~~/common/stores/breadcrumb.js';
  import { LvHeading } from '~~/common/components/loginet-vue-shop/index';
  import AwCmsWhiteCard from '~~/common/components/AwCmsWhiteCard.vue';
  import AwContactUs from '~~/common/components/AwContactUs.vue';
  import AwSeparator from '~~/common/components/Common/AwSeparator.vue';
  import AwSpring from '~~/common/components/AwSpring.vue';
  import AwBreadcrumbVersion2 from '~~/common/components/Common/AwBreadcrumbVersion2.vue';
  import AwAggregatedPageCards from '~~/shop/app/components/Common/AggregatedPages/AwAggregatedPageCards.vue';
  import AwAggregatedPageHighlightedCarousel from '~~/shop/app/components/Common/AggregatedPages/AwAggregatedPageHighlightedCarousel.vue';
  import { defineI18nRoute } from '#i18n';

  const AwSelectVersion2 = defineAsyncComponent(() => import('~~/common/components/Common/AwSelectVersion2.vue'));

  defineOptions({
    name: 'PressPage',
  });
  // eslint-disable-next-line no-undef
  definePageMeta({
    layout: 'full-width',
  });
  const { $awt } = useNuxtApp();
  provide('getRowIndexById', () => 0);

  const contacts = ref([
    {
      icon: 'mailbox-24',
      title: $awt('aw.pages.press.contacts.contact.title'),
      href: '#',
      label: $awt('aw.pages.press.contacts.contact.label'),
    },
    {
      icon: 'mailbox-24',
      title: $awt('aw.pages.press.contacts.question.title'),
      href: `mailto:${$awt('aw.pages.press.contacts.question.mail')}`,
      label: $awt('aw.pages.press.contacts.question.label'),
    },
  ]);
  const yearOptions = computed(() => {
    const currentYear = new Date().getFullYear();
    const years = [];

    for (let i = 0; i < 42; i++) {
      const yearObject = {
        id: currentYear - i,
        name: `${currentYear - i}`,
      };

      years.push(yearObject);
    }

    return years;
  });

  // yearOptions always yields 42 entries, so [0] is never undefined; the
  // non-null assertion just satisfies noUncheckedIndexedAccess.
  const selectedYear = ref<{ id: number, name: string }>(yearOptions.value[0]!);

  const breadcrumbStore = useBreadcrumbStore();
  breadcrumbStore.setBreadcrumbs([
    {
      token: $awt('aw.common.category.home'),
      to: '/',
      disabled: false,
    },
    {
      token: $awt('aw.pages.press.title'),
      to: 'press',
      disabled: true,
    },
  ]);

  false && /*#__PURE__*/ defineI18nRoute({
    paths: {
      en: '/press',
      hu: '/sajtokozlemenyek',
    },
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
.head {
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;

  @include tablet(min) {
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: 40px;
  }

  &Search {
    width: 100%;
    @include tablet(min) {
      width: 248px;
      max-width: 520px;
    }
  }
}

.contactTitle {
  margin-bottom: 20px;
  @include tablet(min) {
    margin-bottom: 40px;
  }
}

.breadcrumb {
  margin-bottom: 20px;
  @include tablet(min) {
    margin-bottom: 40px;
  }
}

.card {
  margin-bottom: 20px;
  @include tablet(min) {
    margin-bottom: 40px;
  }
}
</style>
